module.exports = __webpack_public_path__ + "a21e7c6dea2922986ecc8ba45da9233c.png";